import { Navigate } from 'react-router-dom'
import useRestaurantCodes from '../../hooks/useRestaurantCodes'

const FoodRedirect = () => {
    const { codeSite, codeTable } = useRestaurantCodes()
    return <Navigate replace to={`/${codeSite}/${codeTable}`} />
}

export default FoodRedirect
